import { createLoadingReducer } from './utils';

export default createLoadingReducer('PAYMENT_SETTINGS');
